import OrganizationSupport from "models/interfaces/organization-support";
import { Record } from "immutable";

const defaultValues: OrganizationSupport = {
    name: "",
    emailAddress: "",
    phoneNumber: "",
    website: "",
    contactFullname: "",
};

export default class OrganizationSupportRecord
    extends Record(defaultValues)
    implements OrganizationSupport
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: OrganizationSupport) {
        if (params == null) params = Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor
}
